import { render, staticRenderFns } from "./TaskAssigned.vue?vue&type=template&id=73f2f439&"
import script from "./TaskAssigned.vue?vue&type=script&lang=js&"
export * from "./TaskAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports